import { create } from "zustand";
import type { IPayoutMethod } from "../hooks/http/admin/vendors/payouts/add-bank-account.admin.http";

interface IPayoutMethodsStore {
  data: IPayoutMethod[] | null;
  setData: (data: IPayoutMethod[] | null) => void;
  updateById: (id: string, data: IPayoutMethod) => void;
  addPayoutMethod: (data: IPayoutMethod) => void;
}

const usePayoutMethodsStore = create<IPayoutMethodsStore>((set) => ({
  data: null,
  setData: (data: IPayoutMethod[] | null) => set(() => ({ data })),
  updateById: (id: string, data: IPayoutMethod) =>
    set((state) => ({
      data: state.data
        ? state.data.map((item) => (item.id === id ? data : item))
        : null,
    })),
  addPayoutMethod: (data: IPayoutMethod) => {
    set((state) => ({ data: state.data ? [data, ...state.data] : [data] }));
  },
}));

export default usePayoutMethodsStore;
